import { render, staticRenderFns } from "./PrettyBook.vue?vue&type=template&id=791e0670"
import script from "./PrettyBook.vue?vue&type=script&lang=js"
export * from "./PrettyBook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports